import { type FC } from 'react'
import { TrialTimeline } from '../../Common/TrialTimeline'
import { type DeltaTrialTimelineProps } from '../Timeline/DeltaTrialTimeline'

export const ZapierIntegrationTimeline: FC<DeltaTrialTimelineProps> = (props) => {
  return <TrialTimeline featureName='the Zapier Integration' {...props} />
}
